import { css } from "@emotion/css";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@octopusdeploy/design-system-components";
import { space, text } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import semver from "semver/preload";
import { sentenceCase } from "~/areas/insights/dataTransformation/stringHelpers";
interface ProcessTemplateUpdateDialogProps {
    open: boolean;
    onClose: () => void;
    onUpdateVersion: () => void;
    currentVersion: string | undefined;
    latestVersion: string | undefined | null;
}
export function ProcessTemplateUpdateDialog({ open, onClose, onUpdateVersion, currentVersion, latestVersion }: ProcessTemplateUpdateDialogProps) {
    const handleUpdateClick = () => {
        onUpdateVersion();
        onClose();
    };
    return (<Dialog open={open} dialogWidth="600px">
            <DialogTitle className={styles.title}>{`Release version: v${latestVersion} ${getVersionChangeTypeText(currentVersion, latestVersion)}`}</DialogTitle>
            <DialogContent>
                <div className={styles.contentContainer}>
                    <p className={styles.sectionHeader}> These areas may have changed:</p>
                    <ul className={styles.list}>
                        <li>Parameters added or removed.</li>
                        <li>Steps added or removed.</li>
                    </ul>
                    <p className={styles.sectionHeader}>Action required:</p>
                    <ul className={styles.list}>
                        <li>Review change before updating.</li>
                    </ul>
                </div>
            </DialogContent>
            <DialogActions>
                <Button importance="secondary" label="Update Later" onClick={onClose}/>
                <Button importance="primary" label="Update Version" onClick={handleUpdateClick}/>
            </DialogActions>
        </Dialog>);
}
function getVersionChangeTypeText(currentVersion: string | undefined, latestVersion: string | undefined | null): string | null {
    if (!currentVersion || !latestVersion) {
        return null;
    }
    const changeType = semver.diff(currentVersion, latestVersion);
    return changeType ? `(${sentenceCase(changeType)})` : null;
}
const styles = {
    title: css({
        font: `${text.heading.small} !important`,
        paddingTop: `${space[24]} !important`,
    }),
    contentContainer: css({
        font: text.body.regular.medium,
    }),
    sectionHeader: css({
        font: text.body.bold.medium,
        marginBottom: 0,
    }),
    list: css({
        margin: 0,
        marginInlineStart: space[12],
        listStylePosition: "inside",
        listStyleType: "disc",
    }),
};
